export interface IForgotPasswordResponse {
  successful: boolean;
  message: string;
}

export class ForgotPasswordResponse implements IForgotPasswordResponse {
  successful: boolean;
  message: string;
}
